export default __webpack_public_path__ + "static/media/gracefullyDone.4a2cb991.png";